import React, { useEffect, useRef } from "react";
import styles from "./style.module.css";

interface VideoModalProps {
  isOpen: boolean;
  onClose: () => void;
  videoSrc?: string;
  youtubeId?: string;
  isYouTube?: boolean;
}

const VideoModal: React.FC<VideoModalProps> = ({ isOpen, onClose, videoSrc, youtubeId, isYouTube }) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (!isOpen) return;

    if (!isYouTube && videoRef.current) {
      const video = videoRef.current;
      video.play();
      const handleEnded = () => onClose();
      video.addEventListener("ended", handleEnded);
      return () => video.removeEventListener("ended", handleEnded);
    }
  }, [isOpen, isYouTube, onClose]);

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        {isYouTube && youtubeId ? (
          <iframe
            src={`https://www.youtube.com/embed/${youtubeId}?autoplay=1`}
            title="YouTube Video"
            allow="autoplay; encrypted-media"
            allowFullScreen
            className={styles.modalIframe}
          />
        ) : (
          <video ref={videoRef} controls className={styles.modalVideo} poster="">
            <source src={videoSrc} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        )}
        <button onClick={onClose} className={styles.closeButton}>
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_427_17454" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
              <rect width="32" height="32" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_427_17454)">
              <path
                d="M16 17.1794L9.0102 24.1692C8.84954 24.3299 8.6551 24.4123 8.4269 24.4166C8.1987 24.4209 7.99999 24.3384 7.83077 24.1692C7.66153 24 7.5769 23.8034 7.5769 23.5795C7.5769 23.3555 7.66153 23.159 7.83077 22.9897L14.8205 16L7.83077 9.0102C7.67008 8.84954 7.5876 8.6551 7.58334 8.4269C7.57905 8.1987 7.66153 7.99999 7.83077 7.83077C7.99999 7.66153 8.19656 7.5769 8.42047 7.5769C8.6444 7.5769 8.84098 7.66153 9.0102 7.83077L16 14.8205L22.9897 7.83077C23.1504 7.67008 23.3448 7.5876 23.573 7.58334C23.8012 7.57905 23.9999 7.66153 24.1692 7.83077C24.3384 7.99999 24.423 8.19656 24.423 8.42047C24.423 8.6444 24.3384 8.84098 24.1692 9.0102L17.1794 16L24.1692 22.9897C24.3299 23.1504 24.4123 23.3448 24.4166 23.573C24.4209 23.8012 24.3384 24 24.1692 24.1692C23.9999 24.3384 23.8034 24.423 23.5795 24.423C23.3555 24.423 23.159 24.3384 22.9897 24.1692L16 17.1794Z"
                fill="black"
              />
            </g>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default VideoModal;
